import { Modal } from 'native-base'
import { useMemo } from 'react'

import { IAdjustGeopinToast, IOverlayState, IToggleMapModalToastProps } from '../../context/OverlayContext'
import { Order } from '@consumer/graphql'
import { OrderMap, ProofOfServicePhoto } from './OrderMap'

interface IMapModalProps {
  isOpen: boolean
  onClose: () => void | undefined
  toggleMap: ({ showToastAfterClose, toastProps }: IToggleMapModalToastProps) => void | undefined
  order: Order
  proofOfServicePhotos?: ProofOfServicePhoto[]
  userAuthed?: boolean
  acceptedTermsAndConditions?: boolean
  toggleModal: IOverlayState['toggleModal']
  handleSetOrder: IOverlayState['handleSetOrder']
  toggleEditAddress: IOverlayState['toggleEditAddress']
  adjustGeopinToast: IAdjustGeopinToast
  handleSetAdjustGeopinToast: IOverlayState['handleSetAdjustGeopinToast']
  useUpdateNormalizedAddress: boolean
  setUseUpdateNormalizedAddress: IOverlayState['setUseUpdateNormalizedAddress']
}

export const MapModal = ({
  isOpen,
  toggleMap,
  order,
  toggleModal,
  proofOfServicePhotos,
  userAuthed,
  acceptedTermsAndConditions,
  handleSetOrder,
  toggleEditAddress,
  adjustGeopinToast,
  handleSetAdjustGeopinToast,
  useUpdateNormalizedAddress,
  setUseUpdateNormalizedAddress,
}: IMapModalProps) => {
  const handleAddInstructions = () => {
    toggleMap({ showToastAfterClose: false })
    toggleModal({ showModal: true, auth_flow: 'instructions' })
  }

  const showMarker = useMemo(() => {
    const orderFieldsNotDefined =
      order?.instructionEditsAllowed === undefined ||
      order?.isOrderReroutableByConsumer === undefined ||
      order?.isOrderReroutable === undefined ||
      order?.rerouteBlockedByClient === undefined

    return orderFieldsNotDefined
      ? true
      : order?.instructionEditsAllowed &&
          order?.isOrderReroutableByConsumer &&
          order?.isOrderReroutable &&
          !order?.rerouteBlockedByClient
  }, [order])

  return (
    <Modal isOpen={isOpen} size={'xl'}>
      <OrderMap
        order={order as Order}
        proofOfServicePhotos={proofOfServicePhotos}
        userAuthed={userAuthed}
        acceptedTermsAndConditions={acceptedTermsAndConditions}
        fullScreenMap={true}
        toggleMap={toggleMap}
        orderMapStyles={{
          orderMapContainer: {
            position: 'absolute',
            height: '100%',
            zIndex: 2000,
            width: '100%',
          },
          mapContainer: {
            height: '100vh',
            width: '100wh',
            borderRadius: 0,
            overflow: 'show',
          },
        }}
        addInstructions={handleAddInstructions}
        editAddress={toggleEditAddress}
        showMarkerPopupForAddress={!!showMarker}
        showMapModal={isOpen}
        handleSetOrder={handleSetOrder}
        showGeocodeCorrection={true}
        adjustGeopinToast={adjustGeopinToast}
        handleSetAdjustGeopinToast={handleSetAdjustGeopinToast}
        useUpdateNormalizedAddress={useUpdateNormalizedAddress}
        setUseUpdateNormalizedAddress={setUseUpdateNormalizedAddress}
      />
    </Modal>
  )
}
